import { Component, inject, Input, OnInit } from '@angular/core';
import { GeneralStatusService } from '../../services/general-status.service';
import { Alarms } from './alarms-interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-general-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './general-status.component.html',
  styleUrl: './general-status.component.scss',
})
export class GeneralStatusComponent implements OnInit {
  alarms: Alarms | undefined;
  @Input() installationIds?: string;
  constructor(private serviceStatus: GeneralStatusService) {}

  ngOnInit(): void {
    this.getStatusAlarms();
    setInterval(() => {
      this.getStatusAlarms();
    }, 60000);
  }

  getStatusAlarms() {
    this.serviceStatus.getAlarms(this.installationIds).subscribe({
      next: (data) => {
        this.alarms = data;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
}
